/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, FormGroup, ReactiveFormsModule }   from '@angular/forms';
import { LogincallbackComponent } from '../../projects/icemedx-lib/src/login/logincallback/logincallback.component';
import { LoginflowComponent } from '../../projects/icemedx-lib/src/login/loginflow/loginflow.component';
import { LoginResolver } from "../../projects/icemedx-lib/src/login/login.resolver";
import { LoginGuard } from '../../projects/icemedx-lib/src/login/login.guard';
import { LoginConfig } from "../../projects/icemedx-lib/src/login/login.config";
import { DashboardComponent } from './dashboard/dashboard.component';
import { DomainComponent } from './domain/domain.component';
import { SitemapComponent } from './sitemap/sitemap.component';
import { LandingComponent } from './landing/landing.component';
import { environment } from "../../src/environments/environment";

import { MessagesComponent } from '../../projects/messages/src/app/messages/messages.component';
import { NewmessageComponent } from '../../projects/messages/src/app/newmessage/newmessage.component';
import { ForwardmessageComponent } from '../../projects/messages/src/app/newmessage/forwardmessage.component';
import { ReplymessageComponent } from '../../projects/messages/src/app/newmessage/replymessage.component';
import { ViewmessageComponent } from '../../projects/messages/src/app/viewmessage/viewmessage.component';

import { MainComponent } from '../../projects/patientkiosk/src/app/main/main.component';
import { NameofpatientComponent } from '../../projects/patientkiosk/src/app/nameofpatient/nameofpatient.component';
import { FullprofileComponent } from '../../projects/patientkiosk/src/app/fullprofile/fullprofile.component';
import { ReasonforadmissionComponent } from '../../projects/patientkiosk/src/app/reasonforadmission/reasonforadmission.component';
import { PatientregistrationcompleteComponent } from '../../projects/patientkiosk/src/app/patientregistrationcomplete/patientregistrationcomplete.component';

import { ReportsComponent } from '../../projects/reports/src/app/reports/reports.component';
import { ReportComponent } from '../../projects/reports/src/app/report/report.component';
import { ViewreportComponent } from '../../projects/reports/src/app/viewreport/viewreport.component';
import { PrintreportComponent } from '../../projects/reports/src/app/viewreport/printreport.component';

import { AppService } from '../../projects/patientkiosk/src/app/app.service';
import { MembersComponent } from 'projects/icemedx-lib/src/lib/members/members.component';
import { InviteComponent } from 'projects/icemedx-lib/src/lib/invite/invite.component';

import { PatientdashboardComponent } from 'projects/patientportal/src/app/patientdashboard/patientdashboard.component';
import { PhrcontactComponent } from 'projects/patientportal/src/app/phrcontact/phrcontact.component';
import { PhrappointmentsComponent } from 'projects/patientportal/src/app/phrappointments/phrappointments.component';
import { PhrappointmentdetailsComponent } from 'projects/patientportal/src/app/phrappointmentdetails/phrappointmentdetails.component';
import { PhrclinicalsummariesComponent } from 'projects/patientportal/src/app/phrclinicalsummaries/phrclinicalsummaries.component';
import { PhrclinicalnotesComponent } from 'projects/patientportal/src/app/phrclinicalnotes/phrclinicalnotes.component';
import { PhrordersComponent } from 'projects/patientportal/src/app/phrorders/phrorders.component';
import { PhrdocumentsComponent } from 'projects/patientportal/src/app/phrdocuments/phrdocuments.component';
import { PhrmedicationsComponent } from 'projects/patientportal/src/app/phrmedications/phrmedications.component';
import { PhrproblemsComponent } from 'projects/patientportal/src/app/phrproblems/phrproblems.component';
import { PhrallergiesComponent } from 'projects/patientportal/src/app/phrallergies/phrallergies.component';
import { PhrsettingsComponent } from 'projects/patientportal/src/app/phrsettings/phrsettings.component';
import { SurveyComponent } from 'projects/patientportal/src/app/survey/survey.component';
import { PhrprovidersComponent } from 'projects/patientportal/src/app/phrproviders/phrproviders.component';

import { ProviderComponent } from 'projects/domainprofile/src/app/provider/provider.component';
import { VendorComponent } from '../../projects/domainprofile/src/app/vendor/vendor.component';
import { PharmacyComponent } from '../../projects/domainprofile/src/app/pharmacy/pharmacy.component';
import { PayerComponent } from '../../projects/domainprofile/src/app/payer/payer.component';
import { AccountingSummaryComponent } from '../../projects/accounting/src/app/accountingsummary/accountingsummary.component';
import { LedgerComponent } from '../../projects/accounting/src/app/ledger/ledger.component';
import { ItemComponent } from '../../projects/accounting/src/app/item/item.component';
import { InventoryComponent } from '../../projects/accounting/src/app/inventory/inventory.component';
import { ServiceitemChargeComponent } from '../../projects/accounting/src/app/serviceitemcharge/serviceitemcharge.component';
import { BillTemplateComponent } from '../../projects/accounting/src/app/billtemplate/billtemplate.component';
import { BillingTemplatesComponent } from '../../projects/accounting/src/app/billingtemplates/billingtemplates.component';
import { PyrdocumentsComponent } from '../../projects/payer/src/app/pyrdocuments/pyrdocuments.component';
import { SubscribersearchComponent } from '../../projects/search/src/app/subscribersearch/subscribersearch.component';
import { PatientsearchComponent } from '../../projects/search/src/app/patientsearch/patientsearch.component';
import { AddsubscriberComponent } from '../../projects/domainprofile/src/app/addsubscriber/addsubscriber.component';
import { MeetingsComponent } from '../../projects/schedule/src/app/meetings/meetings.component';
import { AddpatientComponent } from '../../projects/domainprofile/src/app/addpatient/addpatient.component';
import { PharmdocumentsComponent } from '../../projects/pharmacy/src/app/pharmdocuments/pharmdocuments.component';
import { BillingstatementComponent } from '../../projects/accounting/src/app/billingstatement/billingstatement.component';
import { ServicechargeHistoryComponent } from '../../projects/accounting/src/app/servicechargehistory/servicechargehistory.component';
import { OutstandingaccountbalanceComponent } from '../../projects/accounting/src/app/outstandingaccountbalance/outstandingaccountbalance.component';
import { SignerResolver } from '../../projects/icemedx-lib/src/login/signer.resolver';
import { SignercallbackComponent } from '../../projects/icemedx-lib/src/login/logincallback/signercallback.component';
import { ListOfMedicationsComponent } from '../../projects/PHR/src/app/listofmedications/listofmedications.component';
import { PaytohistoryComponent } from '../../projects/accounting/src/app/paytohistory/paytohistory.component';
import { PaymentpostingComponent } from '../../projects/accounting/src/app/paymentposting/paymentposting.component';
import { ClaimsbucketComponent } from '../../projects/accounting/src/app/claimsbucket/claimsbucket.component';
import { ClaimshistoryComponent } from '../../projects/accounting/src/app/claimshistory/claimshistory.component';
import { ActivitystatusComponent } from '../../projects/PHR/src/app/activitystatus/activitystatus.component';
import { ClientsearchComponent } from '../../projects/PHR/src/app/clientsearch/clientsearch.component';

declare var require: any;
let app_path: string = "";
let currentEnv: any = require("../../env.json").currentEnv;
let envs: any = require("../../env.json").environments;
if (envs != null) {
    app_path = envs[currentEnv].app_path;
}

console.log("App: " + app_path);
console.log("Env: " + currentEnv);

const routes: Routes = [
    {
        path: LoginConfig.getFormattedPath(app_path, 'loginflow'),
        component: LoginflowComponent
    },
    {
        path: LoginConfig.getFormattedPath(app_path, 'logincallback'),
        component: LogincallbackComponent,
        resolve: { code: LoginResolver },
        pathMatch: 'full'
    },
    {
        path: LoginConfig.getFormattedPath(app_path, 'loginuserid'),
        component: LogincallbackComponent,
        resolve: { suid: LoginResolver }
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'signercallback'),
      component: SignercallbackComponent,
      resolve: { code: SignerResolver },
      pathMatch: 'full'
    },
    {
        path: LoginConfig.getFormattedPath(app_path, 'dashboard'),
        component: DashboardComponent,
        canActivate: [LoginGuard]
    },
    {
        path: LoginConfig.getFormattedPath(app_path, 'providers'),
        component: DomainComponent,
        canActivate: [LoginGuard],
    },
    {
        path: LoginConfig.getFormattedPath(app_path, 'domain/:type'),
        component: DomainComponent,
        canActivate: [LoginGuard]
    },
    {
        path: LoginConfig.getFormattedPath(app_path, 'pharmacies'),
        component: DomainComponent,
        canActivate: [LoginGuard]
    },
    {
        path: LoginConfig.getFormattedPath(app_path, 'payers'),
        component: DomainComponent,
        canActivate: [LoginGuard]
    },
    {
        path: LoginConfig.getFormattedPath(app_path, 'vendors'),
        component: DomainComponent,
        canActivate: [LoginGuard]
    },
    {
        path: LoginConfig.getFormattedPath(app_path, 'sitemap'),
        component: SitemapComponent,
        canActivate: [LoginGuard]
    },
    {
        path: LoginConfig.getFormattedPath(app_path, 'messages'),
        component: MessagesComponent,
        canActivate: [LoginGuard]
    },
    {
        path: LoginConfig.getFormattedPath(app_path, 'patientkiosk'),
        component: MainComponent,
        canActivate: [LoginGuard]
    },
    {
        path: LoginConfig.getFormattedPath(app_path, 'nameofpatient'),
        component: NameofpatientComponent,
        canActivate: [LoginGuard]
    },
    {
        path: LoginConfig.getFormattedPath(app_path, 'fullprofile'),
        component: FullprofileComponent,
        canActivate: [LoginGuard]
    },
    {
        path: LoginConfig.getFormattedPath(app_path, 'reasonforadmission'),
        component: ReasonforadmissionComponent,
        canActivate: [LoginGuard]
    }, 
    {
        path: LoginConfig.getFormattedPath(app_path, 'registrationcomplete'),
        component: PatientregistrationcompleteComponent,
        canActivate: [LoginGuard]
    }, 
    {
        path: LoginConfig.getFormattedPath(app_path, 'messages/:value'),
        component: MessagesComponent,
        canActivate: [LoginGuard]
    },
    {
        path: LoginConfig.getFormattedPath(app_path, 'newmessage'),
        component: NewmessageComponent,
        canActivate: [LoginGuard]
    },
  {
    path: LoginConfig.getFormattedPath(app_path, 'newmessage/:key'),
    component: NewmessageComponent,
    canActivate: [LoginGuard]
  },
    {
      path: LoginConfig.getFormattedPath(app_path, 'newmessage/:key/:member'),
      component: NewmessageComponent,
      canActivate: [LoginGuard]
    },
    {
        path: LoginConfig.getFormattedPath(app_path, 'viewmessage/:key'),
        component: ViewmessageComponent,
        canActivate: [LoginGuard]
    },
    {
        path: app_path == '/' ? '#' : app_path.replace("/", ""),
        redirectTo: LoginConfig.getFormattedPath(app_path, 'dashboard', true),
        pathMatch: 'full'
    },
    {
        path: '',
        redirectTo: LoginConfig.getFormattedPath(app_path, 'dashboard', true),
        pathMatch: 'full'
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'landing/:id'),
      component: LandingComponent
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'forwardmessage/:key'),
      component: ForwardmessageComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'replymessage/:key'),
      component: ReplymessageComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'reports'),
      component: ReportsComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'report/:key'),
      component: ReportComponent,
      canActivate: [LoginGuard]
    },
  {
    path: LoginConfig.getFormattedPath(app_path, 'viewreport/:key'),
    component: ViewreportComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'viewreport/:domaintype/:domain/:key'),
    component: ViewreportComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'printreport/:domaintype/:domain/:key'),
    component: PrintreportComponent,
    canActivate: [LoginGuard]
  },
    {
      path: LoginConfig.getFormattedPath(app_path, 'members'),
      component: MembersComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'invite'),
      component: InviteComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'patientportal'),
      component: PatientdashboardComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'clientportal'),
      component: PatientdashboardComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'patientdashboard'),
      component: PatientdashboardComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'patientportal/contact'),
      component: PhrcontactComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'patientportal/appointments'),
      component: PhrappointmentsComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'patientportal/appointments/detail/:key'),
      component: PhrappointmentdetailsComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'patientportal/clinalsummaries'),
      component: PhrclinicalsummariesComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'patientportal/clinalsummaries/details/:key'),
      component: PhrclinicalnotesComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'patientportal/orders'),
      component: PhrordersComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'patientportal/documents'),
      component: PhrdocumentsComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'patientportal/medications'),
      component: PhrmedicationsComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'patientportal/problems'),
      component: PhrproblemsComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'patientportal/careteam'),
      component: PhrprovidersComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'patientportal/allergies'),
      component: PhrallergiesComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'patientportal/settings'),
      component: PhrsettingsComponent,
      canActivate: [LoginGuard]
    },
    {
      path: LoginConfig.getFormattedPath(app_path, 'patientportal/survey/:domain/:domaintype/:glkey/:srctype/:srckey'),
      component: SurveyComponent,
      canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'domainprofile/provider'),
    component: ProviderComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'domainprofile/vendor'),
    component: VendorComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'domainprofile/pharmacy'),
    component: PharmacyComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'domainprofile/payer'),
    component: PayerComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/summary'),
    component: AccountingSummaryComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/ledger'),
    component: LedgerComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/inventory'),
    component: InventoryComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/inventory/item/:key'),
    component: ItemComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/inventory/item/bynumber/:itemno'),
    component: ItemComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/serviceitemcharge/:key'),
    component: ServiceitemChargeComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/serviceitemchargebydomain/:fromDomainType/:fromDomain/:toDomainType/:toDomain/:sourceRef'),
    component: ServiceitemChargeComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/billtemplate/:key'),
    component: BillTemplateComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/billingtemplates'),
    component: BillingTemplatesComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/statement/:actType/:act/:key'),
    component: BillingstatementComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/outstandingbalance/:key'),
    component: OutstandingaccountbalanceComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/claimsbucket/:key'),
    component: ClaimsbucketComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/servicechargehistory'),
    component: ServicechargeHistoryComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/servicechargehistory/:act'),
    component: ServicechargeHistoryComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/servicechargehistory/:byType/:actType/:act'),
    component: ServicechargeHistoryComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/claimshistory'),
    component: ClaimshistoryComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/paytohistory'),
    component: PaytohistoryComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/paymentposting'),
    component: PaymentpostingComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'accounting/paymentpostingbydomain/:actType/:domain'),
    component: PaymentpostingComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'payer/documents'),
    component: PyrdocumentsComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'payer/patientsearch'),
    component: PatientsearchComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'payer/subscribersearch'),
    component: SubscribersearchComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'payer/subscribersearch/:key'),
    component: SubscribersearchComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'payer/addsubscriber'),
    component: AddsubscriberComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'payer/meetings'),
    component: MeetingsComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'pharmacy/documents'),
    component: PharmdocumentsComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'pharmacy/patientsearch'),
    component: PatientsearchComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'pharmacy/patientsearch/:key'),
    component: PatientsearchComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'pharmacy/addpatient'),
    component: AddpatientComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'pharmacy/meetings'),
    component: MeetingsComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'PHR/listofmedications'),
    component: ListOfMedicationsComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'activitystatus'),
    component: ActivitystatusComponent,
    canActivate: [LoginGuard]
  },
  {
    path: LoginConfig.getFormattedPath(app_path, 'clientsearch'),
    component: ClientsearchComponent,
    canActivate: [LoginGuard]
  },
  { path: '**', component: SitemapComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule, ReactiveFormsModule],
    providers: [LoginResolver, AppService]
})
export class AppRoutingModule { }
